export const ROUTES = {
  LOGIN: '/rewards/login',
  REWARDS_HOME: '/rewards/info',
  DEVICE_CONNECTION_SUCCESS: '/rewards/device-connection-success'
}
